import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/proage-logo.png'


const _hoisted_1 = { class: "uq-header-logo" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 0,
  class: "navbar-content d-flex align-items-center"
}
const _hoisted_4 = {
  id: "navbarToggleExternalContent",
  class: "uq-header-navbar collapse navbar-collapse"
}
const _hoisted_5 = { class: "navbar-nav navbar-nav-list ff-secondary" }
const _hoisted_6 = { class: "menu-item nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-home fw-semi me-8"
}, null, -1)
const _hoisted_8 = { class: "menu-item nav-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-clinic fw-semi me-8"
}, null, -1)
const _hoisted_10 = { class: "menu-item nav-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-user fw-semi me-8"
}, null, -1)
const _hoisted_12 = { class: "menu-item nav-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-circle fw-semi me-8" }, null, -1)
const _hoisted_14 = { class: "menu-item nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-send-hor fw-semi me-12"
}, null, -1)
const _hoisted_16 = { class: "d-none d-lg-block menu-item nav-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-dock-light fw-semi me-12" }, null, -1)
const _hoisted_18 = { class: "menu-item nav-item p-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pdf me-8" }, null, -1)
const _hoisted_20 = { class: "menu-item nav-item p-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-play-light me-8" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_23 = { class: "menu-item nav-item p-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-dock-light me-8" }, null, -1)
const _hoisted_25 = { class: "menu-item nav-item p-0" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-dock-light me-8" }, null, -1)
const _hoisted_27 = { class: "d-flex d-lg-none menu-item nav-item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-pdf me-8" }, null, -1)
const _hoisted_29 = { class: "d-flex d-lg-none menu-item nav-item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-play-light me-8" }, null, -1)
const _hoisted_31 = { class: "d-flex d-lg-none menu-item nav-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-dock-light me-8" }, null, -1)
const _hoisted_33 = { class: "d-flex d-lg-none menu-item nav-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-file-dock-light me-8" }, null, -1)
const _hoisted_35 = { class: "menu-item nav-item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "icon icon-calendar fw-semi me-8"
}, null, -1)
const _hoisted_37 = { class: "menu-item nav-item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-circle fw-bold text-md" }, null, -1)
const _hoisted_39 = { class: "py-8 px-16" }
const _hoisted_40 = { class: "fw-medium text-sm" }
const _hoisted_41 = { class: "text-xs" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_43 = { class: "py-0 px-16 pb-8" }
const _hoisted_44 = ["aria-label"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "hamburger-box" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "aria-hidden": "true",
    class: "hamburger-inner"
  })
], -1)
const _hoisted_46 = [
  _hoisted_45
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_the_logout = _resolveComponent("the-logout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        "aria-label": _ctx.$t('Inicio'),
        to: {name: 'admin.home'},
        class: "navbar-brand logo"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            alt: _ctx.$t('Logo ProAge'),
            class: "header-logo",
            src: _imports_0
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["aria-label", "to"])
    ]),
    (_ctx.authUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  "aria-label": _ctx.$t('Inicio'),
                  to: {name: 'admin.home'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Inicio')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  "aria-label": _ctx.$t('Clínicas'),
                  to: {name: 'admin.clinic.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Clínicas')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  "aria-label": _ctx.$t('Profesionales'),
                  to: {name: 'admin.professional.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Profesionales')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: {name: 'admin.patient.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Pacientes')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_14, [
                (_ctx.can('admin.purchase-authorization.index'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      "aria-label": _ctx.$t('Aut. de compra'),
                      to: {name: 'admin.purchase-authorization.index'},
                      class: "nav-link fw-bold"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Aut. de compra')), 1)
                      ]),
                      _: 1
                    }, 8, ["aria-label", "to"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_dropdown, {
                  id: "user-header-dropdown",
                  "button-classes": "nav-link fw-bold bg-transparent shadow-none px-0",
                  "dropdown-classes": "dropdown-user dropdown-menu-end py-0",
                  "icon-size": "sm"
                }, {
                  button: _withCtx(() => [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Media')), 1)
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("li", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        to: {name: 'admin.resources.index'},
                        class: "nav-link fw-bold w-100 text-start px-16 py-12",
                        onClick: _ctx.closeNavbarCollapse
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Recursos')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "onClick"])
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _createVNode(_component_router_link, {
                        to: {name: 'admin.video.index'},
                        class: "nav-link fw-bold w-100 text-start px-16 py-12",
                        onClick: _ctx.closeNavbarCollapse
                      }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Videoteca')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "onClick"])
                    ]),
                    _hoisted_22,
                    _createElementVNode("li", _hoisted_23, [
                      _createVNode(_component_router_link, {
                        to: {name: 'admin.resource-category.index'},
                        class: "nav-link fw-bold w-100 text-start px-16 py-12",
                        onClick: _ctx.closeNavbarCollapse
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías recursos')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "onClick"])
                    ]),
                    _createElementVNode("li", _hoisted_25, [
                      _createVNode(_component_router_link, {
                        to: {name: 'admin.video-category.index'},
                        class: "nav-link fw-bold w-100 text-start px-16 py-12",
                        onClick: _ctx.closeNavbarCollapse
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías vídeos')), 1)
                        ]),
                        _: 1
                      }, 8, ["to", "onClick"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_27, [
                _createVNode(_component_router_link, {
                  to: {name: 'admin.resources.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Recursos')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_29, [
                _createVNode(_component_router_link, {
                  to: {name: 'admin.video.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_30,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Videoteca')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: {name: 'admin.video-category.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías vídeos')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_33, [
                _createVNode(_component_router_link, {
                  to: {name: 'admin.resource-category.index'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Categorías recursos')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_35, [
                _createVNode(_component_router_link, {
                  "aria-label": _ctx.$t('Agenda'),
                  to: {name: 'admin.calendar'},
                  class: "nav-link fw-bold",
                  onClick: _ctx.closeNavbarCollapse
                }, {
                  default: _withCtx(() => [
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Agenda')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "to", "onClick"])
              ]),
              _createElementVNode("li", _hoisted_37, [
                _createVNode(_component_dropdown, {
                  id: "user-header-dropdown",
                  "disable-icon": true,
                  "button-classes": "text-sm fw-medium bg-transparent shadow-none px-0",
                  class: "d-none d-lg-block",
                  "dropdown-classes": "dropdown-user dropdown-menu-end py-0"
                }, {
                  button: _withCtx(() => [
                    _hoisted_38
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.authUser.name), 1),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.authUser.email), 1)
                    ]),
                    _hoisted_42,
                    _createElementVNode("li", _hoisted_43, [
                      _createVNode(_component_the_logout)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_the_logout, { class: "d-lg-none" })
              ])
            ])
          ]),
          _createElementVNode("button", {
            id: "navbar-custom-toggler",
            "aria-label": _ctx.$t('Menú'),
            "aria-controls": "navbarToggleExternalContent",
            "aria-expanded": "false",
            class: "navbar-toggler hamburger hamburger--slider ms-4 ms-sm-12",
            "data-bs-target": "#navbarToggleExternalContent",
            "data-bs-toggle": "collapse",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_46, 8, _hoisted_44)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}